// The auth-device /find response message is "Confirm login for <clientInfo> at <ipLocation>".
// Split on the LAST " at " (device names may contain " at ") into the device label and
// location. The label keeps its "Confirm login for …" phrasing to mirror the native app.
export const parseDeviceMessage = message => {
  if (!message || typeof message !== 'string') return { deviceLabel: '', location: '' }
  const marker = ' at '
  const idx = message.lastIndexOf(marker)
  let deviceLabel = message
  let location = ''
  if (idx !== -1) {
    deviceLabel = message.slice(0, idx)
    location = message.slice(idx + marker.length).trim()
  }
  return { deviceLabel: deviceLabel.trim(), location }
}
